import IconX from '@pano-project/assets/icons/IconX';

const Modal = ({
  children,
  backdropEnabled,
  onClose,
  closeIcon,
  fixedPosition,
  disableBackdropClose,
  onCloseIcon,
  className = '',
  topAligned = false,
}) => {
  const handleBackdropClick = disableBackdropClose ? undefined : onClose;
  const handleCloseIconClick = onCloseIcon || onClose;

  return (
    <div
      className={`pano-modal ${fixedPosition ? '_fixed' : ''} ${topAligned ? '_top-aligned' : ''} ${className}`}
    >
      {backdropEnabled && <div onClick={handleBackdropClick} className="pano-modal__backdrop" />}
      <div className={'pano-modal__content'}>
        {closeIcon && (
          <span onClick={handleCloseIconClick} className="pano-modal__close">
            <IconX />
          </span>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
